import React, { useContext } from 'react';
import { Row, Col } from 'react-bootstrap';
import { AlignmentWithSDGStatusWithText } from './AlignmentWithSDGStatus';
import StatusSemaphore from './StatusSemaphore';
import TrendArrow from './TrendArrow';
import { formatStatusScore, formatTrendScore } from '../utils/scoreFormatUtils';
import { GoalsContext } from '../State/GoalsContext';
import { getGoalDisplayTitle, getGoalIconUrl, onGoalIconError } from '../utils/goalDisplayTitle';
import '../utils/sharedStyles.css';

const GoalInfo = ({ goal }) => {
  const { goalType } = useContext(GoalsContext);
  const isUN = goalType === 'un';

  const statusCategory = goal?.computed?.goal_semaphore_status;
  const statusScore = goal?.computed?.goal_status_score;
  const trendCategory = goal?.computed?.goal_trend_status;
  const trendScore = goal?.computed?.goal_trend_score;
  const hasAssessment = statusCategory || trendCategory || statusScore != null || trendScore != null;
  const trendScoreDisplay = formatTrendScore(trendScore);

  return (
    <div className="goal-info-panel">
      <Row className="sdg-details-left-container">
        <Col xs={12}>
          <img
            src={getGoalIconUrl(goal)}
            alt={getGoalDisplayTitle(goal)}
            className="goal-icon"
            onError={(e) => onGoalIconError(e, goal)}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <h3 className="goal-details-title goal-details-title-text">
            {getGoalDisplayTitle(goal)}
          </h3>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <p className="goal-description-text">{goal.acf?.description || ''}</p>
          {!isUN && (
            <p className="goal-description-text text-muted" style={{ fontSize: '0.85rem' }}>
              EU SDG goal scores require valid published data on at least 50% of indicators in the goal.
              Status compares Kosovo to the default benchmark group (EU27). Kosovo status uses Kosovo&apos;s latest available year; EU27 countries share a common comparison year. Goal progress uses five categories (including stagnation).
            </p>
          )}
        </Col>
      </Row>
      <Row className="goal-assessment-row">
        <Col xs={12}>
          <div className="section-title section-title-spacing">
            <h6 className="sdg-section-title">Goal Assessment</h6>
          </div>

          {hasAssessment ? (
            <div className="goal-assessment-cards">
              {!isUN && (statusCategory || statusScore != null) && (
                <div className="goal-assessment-box">
                  <h6 className="goal-assessment-box-title">Status</h6>
                  <div className="goal-assessment-box-body">
                    <StatusSemaphore
                      category={statusCategory}
                      score={null}
                      size={28}
                      showCaption={false}
                    />
                    <div className="goal-assessment-summary">
                      <div className="goal-assessment-primary-label">
                        {statusCategory || 'Insufficient data'}
                      </div>
                      <div className="goal-assessment-value-score">
                        Score: {statusScore != null ? `${formatStatusScore(statusScore)} / 100` : '— / 100'}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {(trendCategory || trendScore != null) && (
                <div className="goal-assessment-box">
                  <h6 className="goal-assessment-box-title">Progress</h6>
                  <div className="goal-assessment-box-body">
                    <TrendArrow
                      category={trendCategory}
                      score={trendScore}
                      size={28}
                      showCaption={false}
                    />
                    <div className="goal-assessment-summary">
                      <div className="goal-assessment-primary-label">
                        {trendCategory || 'Insufficient data'}
                      </div>
                      <div className="goal-assessment-value-score">
                        Score: {trendScoreDisplay != null ? `${trendScoreDisplay} / 5` : '— / 5'}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <AlignmentWithSDGStatusWithText alignmentStatus={goal.acf?.alignment_with_sdg_data?.status || '0'} />
          )}
        </Col>
      </Row>
      <hr className="goal-info-hr" />
    </div>
  );
};

export default GoalInfo;
